<div class="grid-column" style="display: none;">
  <div class="grid-header" [innerHTML]="component.primary.column"></div>
  @for (tr of component.fields; track tr) {
    <div class="grid-body" [innerHTML]="tr.row"></div>
  }
</div>
<span class="gridHolder" [ngStyle]="getWidthStyle(max_width)"></span>
